import { FeLogger } from '@/addons/monitoring'

/**
 * Message from Clienteling
 * {
 *   "data": {
 *     "subType": "30_min_before",
 *     "notificationType": "TASK_REMINDER",
 *     "title": "Inizia tra 30min",
 *     "body": "Non dimenticare! Il tuo evento inizia tra 30 minuti."
 *   },
 *   "notification": {
 *     "title": "Inizia tra 30min",
 *     "body": "Non dimenticare! Il tuo evento inizia tra 30 minuti.",
 *     "image": null
 *   }
 * }
 */
const isClientelingNotification = (message) => {
  const types = ['TASK_REMINDER', 'CONVERSATIONS']
  const { data } = message
  if (data?.notificationType && types.indexOf(data?.notificationType) !== -1) {
    return true
  }
  return false
}

// TODO: change with the right implementation and remove 'alert'
export const renderNotification = (message) => {
  const msgData = JSON.stringify(message)
  FeLogger.info(msgData)

  // TODO: Check message structure
  if (isClientelingNotification(message)) {
    // eslint-disable-next-line no-alert
    alert(JSON.stringify(msgData))
  } else {
    // eslint-disable-next-line no-alert
    alert(JSON.stringify(msgData))
  }
}
